<template>
  <!-- data.imagePosition -->
  <div class="feature u-row u-pad-y-xl u-pad-y-md--sm">
    <div v-if="!data.mediaPosition" class="u-w5of12 u-marg-l-1of12 u-pad-x-0--sm  u-w10of12--sm u-marg-l-1of12--sm u-marg-b-md--sm u-flex u-center u-middle u-radius u-overflow-hidden">
      <app-image
        :id="data.media[0].id"
        :src="data.media[0].url"
        :width="1544"
        :height="1000"
        alt="Project picture"
        v-if="isImage"
        class="u-fit-cover"
      />
      <div v-else class="u-w12of12 u-relative u-box-16by9 u-overflow-hidden">
        <video-player :src="data.media[0].url" class="u-radius u-overflow-hidden" :forcePlay="data.isMediaAutoPlay"/>
      </div>
    </div>
    <div class="u-w4of12 u-marg-x-1of12 u-left u-w10of12--sm">
      <p class="t-h3 u-blue u-marg-b-md">
        {{data.titre}}
      </p>
      <p class="t-text u-marg-b-md u-white-space">{{data.description}}</p>
      <div class="u-left u-center--sm">
        <app-button class="feature__button u-marg-r-md u-marg-r-sm--sm u-marg-b-md u-marg-t-xs" v-if="data.cta.length" v-for="(cta, index) in data.cta" :key="index" :url="cta.href" :isGhost="index % 2 !== 0">
          <span class="t-text--small">
            {{cta.label}}
          </span>
        </app-button>
      </div>
    </div>
    <div v-if="data.mediaPosition" class="u-w5of12 u-w10of12--sm u-marg-l-1of12--sm u-marg-t-md--sm u-relative u-flex u-center u-middle u-radius u-overflow-hidden">
      <app-image
        :id="data.media[0].id"
        :src="data.media[0].url"
        :width="1544"
        :height="1000"
        alt="Project picture"
        class="u-fit-cover"
        v-if="isImage"
      />
      <div v-else class="u-fit-cover u-relative">
        <video-player :src="data.media[0].url"/>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/common/AppButton'
import VideoPlayer from '@/components/VideoPlayer'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },

  components: {
    AppButton,
    VideoPlayer
  },
  
  data() {
    let isImage = true
    if (this.data.media.length) {
      let fileType = this.data.media[0].extension.toLowerCase()
      if(['mp4', 'm4v'].includes(fileType)) {
        isImage = false
      }
    }
    return {
      isImage: isImage
    }
  }
}
</script>

<style lang="stylus">
.feature
  &__button
    &:last-child
      margin-right 0
</style>